import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NoteForm } from '../../molecules/NoteForm/NoteForm';
import { Button } from '../../atoms/Button/Button';
import './CreateNotePage.css';

export const CreateNotePage: React.FC = () => {
  const navigate = useNavigate();
  // Temporary userId for testing
  const userId = 'test-user-123';

  const handleNoteCreated = () => {
    navigate('/');
  };

  return (
    <div className="create-note-page">
      <div className="create-note-page__header">
        <Button variant="secondary" onClick={() => navigate('/')}>
          Back to Home
        </Button>
      </div>
      <h1>Create New Note</h1>
      <NoteForm userId={userId} onNoteCreated={handleNoteCreated} />
    </div>
  );
}; 